import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ManagedInput from 'components/form/managed_input';
import Options from 'components/form/managed_input/options';

import type { Contact as ContactType, ContactsTask } from 'bundles/apex/tasks/types';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';

interface Props {
  contacts: ContactType[];
  contactsTask: ContactsTask;
  onChange: (contactsTask: ContactsTask) => void;
  onDelete: (contactsTask: ContactsTask) => void;
}

export default function Contact({ contacts, contactsTask, onChange, onDelete }: Props) {
  return (
    <div className="d-flex align-items-center mb-3">
      <ManagedInput
        className="form-control me-3"
        includeBlank
        label="Contact"
        type="select"
        value={contactsTask.contact.id}
        onValueChange={contactId => {
          onChange({
            ...contactsTask,
            contact: contacts.find(contact => contact.id === parseInt(contactId))!,
          });
        }}
      >
        <Options
          options={[contactsTask.contact, ...contacts]}
          valueName="id"
        />
      </ManagedInput>

      <FontAwesomeIcon
        className="clickable"
        icon={faTrashCan}
        onClick={() => onDelete(contactsTask)}
      />
    </div>
  );
}
